import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=a44f9792&scoped=true&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"
import style0 from "./Entities.vue?vue&type=style&index=0&id=a44f9792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44f9792",
  null
  
)

export default component.exports